<template>
  <section
    class="virtual_guard__profile_container"
    :class="{'landscape_padding': getScreenOrientation() == 'landscape'}">
    <div class="virtual_guard__background"></div>
    <div class="virtual_guard__profile">
      <div class="virtual_guard__profile_image"></div>
    </div>
    <div class="virtual_guard__call_icon">
      <span @click="call()" v-if="!isCalling">
        <CallIcon></CallIcon>
      </span>
      <span class="virtual_guard__hand_out" @click="hangUp()" v-else>
        <HandOutIcon></HandOutIcon>
      </span>
    </div>
    <div v-if="getShowPhonePrompt() && getScreenOrientation() != 'landscape'" class="virtual_guard__phone_prompt">
      <touch-events v-if="isTouch" :sublocation_id="sublocation_id" @closePhoneValidation="updateShowPhonePrompt(false)"></touch-events>
      <voice-event v-else :sublocation_id="sublocation_id" @closePhoneValidation="updateShowPhonePrompt(false)"></voice-event>
      <!--
      <p class="virtual_guard__phone_prompt_text virtual_guard__bold_text">Responde:</p>
       -->
    </div>
  </section>
</template>
<script>

import CallIcon from "@/components/shared/icons/CallIcon.vue";
import HandOutIcon from "@/components/shared/icons/HandOutIcon.vue";
import TouchEvents from "./TouchEvents.vue";
import VoiceEvent from "@/views/components/VoiceEvent.vue";

export default {
  components: {
    CallIcon,
    HandOutIcon,
    //TalkIcon,
    TouchEvents,
    VoiceEvent,
  },
  props: {
    sublocation_id: {
      type: String,
      required: true,
    },
    connection_id: {
      type: String,
      required: true,
    },
    sublocation_info: {}
  },
  data() {
    return {
      audio: null,
      isCalling: false,
      callTimer: null,
      isTouch: false,
      showPhonePrompt: false,
      timeoutSeconds: 0,
      timeoutInterval: null,
      responseTimeout: null
    }
  },
  created() {
    this.isTouch = this.$route.query.istouch === 'true';
    document.addEventListener('keydown', this.buttonAction);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.buttonAction);
    this.clearTimeouts();
  },
  methods: {
    buttonAction(event) {
      if (this.getShowPhonePrompt()) return;
      if (event.keyCode !== 65) return;
      if (this.isCalling) {
        this.hangUp();
      } else {
        this.call();
      }
    },
    responseCall() {
      this.$emit('responseCall', true);
    },
    call() {
      if (this.getShowPhonePrompt()) return;
      const room = `room_virtual_guard_${this.sublocation_id}`;
      this.audio = new Audio(require('@/assets/audio/calling.mp3'));
      this.audio.play();
      this.isCalling = true;
      this.$cable.perform({
        channel: "VirtualGuardChannel",
        action: 'send_message',
        data: {
          room,
          message: 'call',
          sublocation_info: this.sublocation_info,
          sublocation_id: this.sublocation_id,
          connection_id: this.connection_id,
          calling: true,
        }
      });

      let timer = 0;
      var vm = this
      this.callInterval = setInterval(() => {
        timer++;
        if (timer === 45) {
          this.hangUp();
          setTimeout(() => {
            vm.updateShowPhonePrompt(true);
          }, 1000);
          clearInterval(this.callInterval);
        }
      }, 1000);
    },
    hangUp() {
      this.isCalling = false;
      if (this.audio) this.audio.pause();
      if (this.callInterval)
        clearInterval(this.callInterval);
      const room = `room_virtual_guard_${this.sublocation_id}`;
      this.$cable.perform({
        channel: 'VirtualGuardChannel',
        action: 'send_message',
        data: {
          calling: false,
          sublocation_id: this.sublocation_id,
          connection_id: this.connection_id,
          room,
          message: 'hangUp'
        }
      });
    },

    clearTimeouts() {
      clearInterval(this.timeoutInterval);
      clearTimeout(this.responseTimeout);
      this.timeoutInterval = null;
      this.responseTimeout = null;
    },
  },
  channels: {
    VirtualGuardChannel: {
      received(data) {
        const connectionId = data.data.connection_id;
        if (connectionId !== this.connection_id) {
          if (data.data.calling === false && data.data.message === 'hangUp') {
            this.hangUp();
            clearInterval(this.callInterval);
            this.updateShowPhonePrompt(true);
          } else if (data.data.answer_call === true && data.data.message === 'answerCall') {
            if (this.audio) this.audio.pause();
            clearInterval(this.callInterval);
            this.responseCall();
          }
        }
      }
    }
  }
}
</script>
<style>
.virtual_guard__phone_prompt {
  margin-top: 20px;
  padding: 2rem;
  background-color: rgb(218, 218, 218);
  border-radius: 42px;
  color: white;
  text-align: start;
  z-index: 3;
  position: fixed;
  bottom: 12vh;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 90%;
  left: 50%;
  transform: translateX(-50%);
}

.virtual_guard__timeout {
  margin-top: 8px;
  font-size: 1.4vh;
  color: #ff1717;
  font-family: poppinsRegular, serif;

  @media screen and (max-width: 900px) {
    font-size: 18px;
  }
}


.virtual_guard__phone_prompt_text {
  font-size: 2vh;
  color: black;
  font-family: poppinsRegular, serif;

  @media screen and (max-width: 900px) {
    font-size: 16px;
  }
}
</style>